import {BehaviorSubject, Subject} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {mc} from '@/core';
import {kycApi} from '@/api/kyc';
import {buyCryptoCardApi} from '@/api/buy-crypto-card';

export const bonus$ = new BehaviorSubject(0);
export const countries$ = new BehaviorSubject([]);
export const countriesBy2$ = new BehaviorSubject({});
export const regions$ = new BehaviorSubject({});
export const allSummary$ = new BehaviorSubject({});
export const basicKycInfo$ = new BehaviorSubject({});
export const basicKycDialog$ = new BehaviorSubject();

export const getBonus$ = new Subject().pipe(switchMap(() => kycApi.getBonus().toRestState()));
export const getCountries$ = new Subject().pipe(switchMap(() => kycApi.getCountries().toRestState()));
export const getRegions$ = new Subject().pipe(switchMap(() => kycApi.getCountryRegions().toRestState()));
export const getAllSummary$ = new Subject().pipe(switchMap(() => kycApi.getAllKycSummary().toRestState()));

getBonus$.subscribe((res) => {
  const {data, error} = res;
  if (data) {
    bonus$.next(data.bonusAmount);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
});

getCountries$.subscribe((res) => {
  const {data, error} = res;
  if (data) {
    countries$.next(
      data.rows.map((c) => {
        return {
          text: c.fullName,
          value: c.simpleNameThree,
          countryCode: c.phoneNoPrefix,
        };
      })
    );
    countriesBy2$.next(data.rows.reduce((map, c) => ({...map, [c.simpleName]: c.simpleNameThree}), {}));
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
});

getRegions$.subscribe((res) => {
  const {data, error} = res;
  if (data) {
    regions$.next(data.rows);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
});

getAllSummary$.subscribe((res) => {
  const {data, error} = res;
  if (data) {
    allSummary$.next(data);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
});

export async function getBasicKycInfo() {
  const {data, error} = await kycApi.getUserBasicKycInfo();
  if (data) {
    basicKycInfo$.next(data);
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  basicKycInfo$.next({});
  return {};
}
